import { useEventAnalytics } from "../../../app/src/analytics/src/AnalyticsProvider";
import {
  Button
} from "@ca-dmv/core";

function AnalyticsButton({
  // Analytics props
  analyticsName,
  analyticsAction,
  analyticsComponent,
  analyticsCustom = {},
  applicationType,

  // Button props
  onClick,
  ...buttonProps
}) {
  const { trackButtonClick } = useEventAnalytics();

  const handleClick = async (event) => {
    // Track analytics
    trackButtonClick(analyticsName, {
      action: analyticsAction || analyticsName,
      componentName: analyticsComponent,
      ...(analyticsCustom || {}),
      ...(applicationType ? { applicationType } : {}),
    }).catch(console.error);

    // Execute original onClick
    if (onClick) onClick(event);
  };

  return <Button {...buttonProps} onClick={handleClick} />;
}

export default AnalyticsButton;